// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37037850","453":"45de8d6c","667":"150a10ef","954":"64a2e295"}[chunkId] + ".chunk.js";
};